import { h } from 'preact';
import { LocaleActions } from 'actions'

function I18n(props) {
    return LocaleActions.translate(props.children) || ""
}
I18n.t=(key)=>(
    LocaleActions.translate(key)
)
export default I18n


// WEBPACK FOOTER //
// ./components/elements/I18n/index.js